import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {JP, query} from "../../helpers/jp";
import {CONDITION_TYPES_LIST} from "../../enums/e-conditions";
import {BusService} from "../../services/bus.service";
declare var $: any;


@Component({
  templateUrl: "./test.component.html"
})


export class TestComponent {
  @ViewChild("rootDiv") rootDiv: ElementRef;
  VALUE_TYPE = VALUE_TYPE;
  CONDITION_TYPES_LIST = CONDITION_TYPES_LIST;

  doc: any = { value: true };


  value: boolean = false;
  enabled: boolean = true;
  model: number = 2;

  @ViewChild("inputNode") element: ElementRef;


  onCheckboxUpdated(value) {
    console.log("checkboxValue: " + value);
  }


  constructor(private busService: BusService) {
  }


  dispatchDisabledDoc() {
    this.busService.emitDocumentUpdated({
      document: null,
      readonly: true,
      user: <any>{ displayName: "aa" }
    });
  }


  dispatchEnabledDoc() {
    this.busService.emitDocumentUpdated({
      document: <any>{},
      readonly: false,
      user: <any>{ displayName: "aa" }
    });
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/pages/test/test.component.ts